
import data from '../assets/data/activities.json'
export const state = () => ({ data })
